"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownCss = void 0;
var utils_1 = require("../../utils/utils");
var DropdownCss = function (target) {
    return /** @class */ (function (_super) {
        __extends(DropdownCss, _super);
        function DropdownCss() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        DropdownCss.prototype.render = function () {
            var dropdown = _super.prototype.render.call(this);
            var dropdownCssClass = this.options.get('dropdownCssClass') || '';
            if (dropdownCssClass.indexOf(':all:') !== -1) {
                dropdownCssClass = dropdownCssClass.replace(':all:', '');
                utils_1.Utils.copyNonInternalCssClasses(dropdown, this.core.element);
            }
            dropdown.classList.add(dropdownCssClass);
            return dropdown;
        };
        return DropdownCss;
    }(target));
};
exports.DropdownCss = DropdownCss;
//# sourceMappingURL=dropdown-css.js.map